/** ***********
*
* <user-right.module.ts v1.0>
*
* Copyright (c) 2022 AIRBUS OPERATIONS
*
* Contributors:
*  PEREIRA Thomas [SOPRA STERIA] [thomas.pereira@soprasteria.com]
*  GARY Adrien (NG635E8) [adrien.gary.external@airbus.com]
*  NG6C740 [thomas.pereira.external@airbus.com]
*
 * All rights reserved.
**************/

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppMaterialModule } from 'src/app/material.modules';
import { SharedTranslationModule } from '../shared/shared-translation.module';
import { DialogModifyRoleComponent } from './dialog/dialog-modify-role/dialog-modify-role.component';
import { ManageUserRoleComponent } from './manage-user-role/manage-user-role.component';
import { MatSelectModule } from '@angular/material/select';
import { DialogAskRoleComponent } from './dialog/dialog-ask-role/dialog-ask-role.component';
import { RequestForRightsComponent } from './request-for-rights/request-for-rights.component';
import { ManageRightRequestComponent } from './manage-right-request/manage-right-request.component';
import { FilterModule } from '../filter/filter.module';
import { DialogSpecificRoleComponent } from './dialog/dialog-specific-role/dialog-specific-role.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ManageFamilyUsersComponent } from './manage-family-users/manage-family-users.component';
import { RoleSelectionComponent } from './_shared/role-selection/role-selection.component';
import { SharedModule } from '../shared/shared.module';
import { FamilyUsersConfirmationDialogComponent } from './manage-family-users/confirmation-dialog/confirmation-dialog.component';
import { ManageGroupsComponent } from './manage-groups/manage-groups.component';
import { DialogEditGroupComponent } from './manage-groups/dialog-edit-group/dialog-edit-group.component';
import { SelectUserComponent } from './manage-groups/_shared/select-user/select-user.component';
import { UserGroupsComponent } from './_shared/user-groups/user-groups.component';
import { SelectFamilyComponent } from './manage-groups/_shared/select-family/select-family.component';
import { DialogRequestGroupComponent } from './dialog/dialog-request-group/dialog-request-group.component';
import { GroupFamiliesListComponent } from './manage-groups/_shared/group-families-list/group-families-list.component';
import { GroupUsersListComponent } from './manage-groups/_shared/group-users-list/group-users-list.component';
import { RouterModule } from '@angular/router';
import { managerGuard } from 'src/app/auth/manager.guard';
import { TranslateModule } from '@ngx-translate/core';
import { specificRoleGuard, UserSpecificRole } from 'src/app/auth/specific-role.guard';

@NgModule({
  declarations: [
    RequestForRightsComponent,
    ManageRightRequestComponent,
    ManageUserRoleComponent,
    DialogModifyRoleComponent,
    DialogAskRoleComponent,
    DialogSpecificRoleComponent,
    ManageFamilyUsersComponent,
    RoleSelectionComponent,
    FamilyUsersConfirmationDialogComponent,
    ManageGroupsComponent,
    DialogEditGroupComponent,
    SelectUserComponent,
    UserGroupsComponent,
    SelectFamilyComponent,
    DialogRequestGroupComponent,
    GroupFamiliesListComponent,
    GroupUsersListComponent
  ],
  imports: [
    CommonModule,
    AppMaterialModule,
    SharedTranslationModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    FilterModule,
    MatFormFieldModule,
    SharedModule,
    TranslateModule.forChild({ extend: true }),
    RouterModule.forChild([
        {
            path: 'request',
            component: RequestForRightsComponent,
        },
        {
            path: 'manage-user-roles',
            component: ManageUserRoleComponent,
            canActivate: [managerGuard],
        },
        {
            path: 'manage-family-users',
            component: ManageFamilyUsersComponent,
            canActivate: [managerGuard],
        },
        {
            path: 'manage-requests',
            component: ManageRightRequestComponent,
            canActivate: [managerGuard],
        },
        {
            path: 'groups',
            component: ManageGroupsComponent,
            canActivate: [specificRoleGuard],
            data: {
                roles: [
                    UserSpecificRole.adminGroups,
                    UserSpecificRole.admin,
                ],
            },
        },
    ]),
  ],
  providers: [],
})
export class UserRightModule { }
